import React from 'react'; 
import { useEffect, useLayoutEffect, useState, useRef } from 'react';
import WithConsumer from '../../context/WithConsumer';
import { Link } from 'react-router-dom';
import Image from '../global/Image';
import Cinemagraph from '../global/Cinemagraph';
import Footer from './../global/Footer';
import Slider from "react-slick";

const Work = ({ context }) => {
	
	const posts = () => context.posts;
    const post = posts()[0];
    
    const slugCtx = () => context.slug;
    const slug = slugCtx();
    
	const [vars, setVars] = useState(false);
	const [curSlug, setCurSlug] = useState(false);
	
	const sliderRef = useRef();
		
	const slickSettings = {
    	dots: true,
		infinite: false,
		speed: 0,
		slidesToShow: 1,
		slidesToScroll: 1,
		beforeChange: (current, next) => {
			
			let slug = getSlug();
			
			let slideIndex = 0;
			
			let addString = '-next';
			if (next < current) {
				addString = '-prev';
			}
			
			if (post) {
				for (let i=0;i<post.projects.length;i++) {
					for (let j=0;j<post.projects[i].gallery.length;j++) {
						
						if (slideIndex === next) {
							if (document.getElementsByClassName('c-dwork__slider__slide')[next].getAttribute('data-slug') !== slug) {
								document.getElementById('view-' + document.getElementsByClassName('c-dwork__slider__slide')[next].getAttribute('data-slug') + addString).click();
							}
						}
						slideIndex = slideIndex + 1;
					}
				}
			}
		}
  	};
  
	useEffect(() => {
		resetVars(true);
    	window.addEventListener('resize', resetVars(true));		
    	return () => window.removeEventListener('resize', resetVars);	
	}, []);
	
	function resetVars(triggeredByResize) {
				
		const slug = getSlug();
		
		let screenWidth = window.innerWidth;
		let screenHeight = window.innerHeight;
		let mobile = false;
		
		if (screenWidth < 760) {
			mobile = true;
		}
				
		let deviceView = 'desktop';
		if (mobile) {
			deviceView = 'mobile';
		}
		
		let layoutView = 'index';
		if (slug !== 'work' && slug !== '') {
			layoutView = 'gallery';
		}
				
		if (slug !== vars.slug || screenWidth !== vars.screenWidth || screenHeight !== vars.screenHeight || vars.mobile !== mobile) {

			setVars({
				screenWidth : screenWidth,
				screenHeight : screenHeight,
				mobile : mobile,
				slug : slug,
				deviceView : deviceView,
				layoutView : layoutView
			});
			
			if (triggeredByResize === false) {
				
				window.scrollTo(0, 1);
						
				snapToPoint(mobile);
				setTimeout(() => {				
					snapToPoint(mobile);
				}, 0);
				
				setTimeout(() => {				
					snapToPoint(mobile);
				}, 250);
				
			}
			
		}
		
		
	}
	
	function getModalIndex() {
		
		const urlParams = new URLSearchParams(window.location.search);
		const view = urlParams.get('view');
		
		let slug = getSlug();
		let index = -1;
		if (view === 'info') {
			for (let i=0;i<post.projects.length;i++) {
				if (post.projects[i].slug === slug) {
					index = i;
				}
			}
		}
		return index;
	}
	
	function snapToPoint(mobile) {
		
		const slug = getSlug();
				
		const urlParams = new URLSearchParams(window.location.search);
		const imageIndex = urlParams.get('image');
				
		if (slug !== '' && mobile === true) {
			
			if (imageIndex === 0 || imageIndex === '0') {
				
				window.scrollTo(0, 0);
				
			} else {
				if (document.getElementById('work-mobile-header') && document.getElementById(slug)) {
					let offset = document.getElementById(slug).offsetTop + document.getElementById('work-mobile-header').clientHeight + 2;
											
					if (imageIndex) {
						offset = offset + document.getElementById(slug + '-' + imageIndex).offsetTop + 12;
					}
									
					window.scrollTo(0, offset);
				
				}
			}
		
		} else if (slug !== '' && mobile === false) {
			
			let id = 'slide-' + slug;
			
			if (imageIndex) {
				id = id + '-' + imageIndex;	
			} else {
				id = id + '-1';	
			}
						
			if (document.getElementById(id)) {
				
				let index = parseInt(document.getElementById(id).getAttribute('data-index'));
				
				sliderRef.current.slickGoTo(index);
				
				window.scrollTo(0, 0);
									
			}
			
			
		} else if (mobile === true) {
			
			window.scrollTo(0,0);
	
		} else if (mobile === false) {
			
			window.scrollTo(0,0);
			
		}
		
	}
	
	function getSlug() {
		return String((window.location + '').split('/work')[1].split('?')[0].replace(/\//g, '') + '');
	}
    
    if (post) {
	    
	    if (post.workloaded) {   
	    
		    let slides = [];
		    let slideIndex = 0;
		    
		    const modalIndex = getModalIndex();
		    
		    for (let i=0;i<post.projects.length;i++) {
			    
			    let nextUrl = '/';
			    if (i === (post.projects.length - 1)) {
			    	nextUrl = post.projects[0].url;
			    } else {
				    nextUrl = post.projects[(i + 1)].url;
			    }
			    
				let prevUrl = '/';
			    if (i === 0) {
			    	prevUrl = post.projects[(post.projects.length - 1)].url;
			    } else {
				    prevUrl = post.projects[(i - 1)].url;
			    }
			    
			    for (let j=0;j<post.projects[i].gallery.length;j++) {
				    
				    let forceLoad = false;
				    if (slideIndex < 16) {
					    forceLoad = true;
				    }
				    
				    slides.push(
					    <div id={'slide-' + post.projects[i].slug + '-' + (j + 1)} className="c-dwork__slider__slide" data-index={slideIndex} data-project-index={j} data-slug={post.projects[i].slug}>
							<div className="c-dwork__slider__slide__media">
								{post.projects[i].gallery[j].type == 'image' &&
									<>
										{forceLoad === true &&
											<Image srcset={post.projects[i].gallery[j].srcset} src={post.projects[i].gallery[j].src} forceLoad={true} />
										}
										{forceLoad === false &&
											<Image srcset={post.projects[i].gallery[j].srcset} src={post.projects[i].gallery[j].src} forceLoad={false} />
										}
									</>
								}
								{post.projects[i].gallery[j].type == 'cinemagraph' &&
									<Cinemagraph src={post.projects[i].gallery[j].src} />
								}
							</div>
							<div className="c-dwork__slider__slide__footer">
								<p className="c-dwork__slider__slide__footer__counter" dangerouslySetInnerHTML={{__html:(j + 1) + '/' + post.projects[i].gallery.length}}></p>
								<h3 className="c-dwork__slider__slide__footer__heading" dangerouslySetInnerHTML={{__html:post.projects[i].title}}></h3>
								{modalIndex === -1 &&
									<Link to={{ pathname: post.projects[i].url + '?view=info'}} className="c-dwork__slider__slide__footer__info" dangerouslySetInnerHTML={{__html:'Information'}}></Link>
								}
								{modalIndex !== -1 &&
									<Link to={{ pathname: post.projects[i].url}} className="c-dwork__slider__slide__footer__info" dangerouslySetInnerHTML={{__html:'Close'}}></Link>
								}
								<Link to={{ pathname: '/work' }} className="c-dwork__slider__slide__footer__index" dangerouslySetInnerHTML={{__html:'Index'}}></Link>
							</div>
						</div>
				    )
				    slideIndex = slideIndex + 1;
				}
		    }
		    	    
		    if (getSlug() !== vars.slug) {
				resetVars(false);
			}	
			
			
			
				
		
			return (					
				
				<div className={'c-work c-load state-' + vars.layoutView}>
					
					{vars.mobile == true &&
					
						<div className="c-mwork">
							
							<div id="work-mobile-header" className="c-mwork__view">
								<Link to={{ pathname: '/work' }} className="c-mwork__view__button">Index</Link>
								<Link to={{ pathname: post.projects[0].url + '?image=0' }} className="c-mwork__view__button">Gallery</Link>
							</div>
							
							<div className="c-mwork__index">
								{post.projects &&
									<>
										{post.projects.map((project,i) =>
											{
												return (
													<section className="c-mwork__index__project" key={i}>
														<header className="c-mwork__index__project__header">
															<h3 className="c-mwork__index__project__header__heading" dangerouslySetInnerHTML={{__html:project.title}}></h3>
															<Link to={{ pathname: project.url }} className="c-mwork__index__project__header__view">View</Link>
														</header>
														<div className="c-mwork__index__project__thumbs">
															{project.gallery.map((thumb,j) =>
																{
																	if (thumb.src) {
																		return (
																			<div className="c-mwork__index__project__thumb" key={j}>
																				<Link to={{ pathname: project.url + '?image=' + (j + 1) }} className="c-mwork__index__project__thumb__inner">
																					{thumb.type == 'image' &&
																						<Image srcset={thumb.srcset} src={thumb.src} />
																					}
																					{thumb.type == 'cinemagraph' &&
																						<Cinemagraph src={thumb.src} />
																					}
																				</Link>
																			</div>
																		)
																	} else {
																		return null;
																	}
																}
															)}
														</div>
													</section>
												)
											}
										)}
									</>
								}
							</div>
							
							<div className="c-mwork__gallery">
								{post.projects &&
									<>
										{post.projects.map((project,i) =>
											{
												return (
													<section id={project.slug} className="c-mwork__gallery__project" key={i}>
														<header id="work-mobile-header" className="c-mwork__gallery__project__header">
															<h3 className="c-mwork__gallery__project__header__heading" dangerouslySetInnerHTML={{__html:project.title}}></h3>
															<Link to={{ pathname: project.url + '?view=info'}} className="c-mwork__gallery__project__header__info">Information</Link>
														</header>
														<div className="c-mwork__gallery__project__media">
															{project.gallery.map((media,j) =>
																{
																	if (media.src) {
																		return (
																			<div id={project.slug + '-' + (j + 1)} className="c-mwork__gallery__project__media__item" key={j}>
																				<div className="c-mwork__gallery__project__media__item__inner">
																					{media.type == 'image' &&
																						<Image width={media.width} height={media.height} srcset={media.srcset} src={media.src} />
																					}
																					{media.type == 'cinemagraph' &&
																						<Cinemagraph width={1920} height={1080} src={media.src} />
																					}
																				</div>
																			</div>
																		)
																	} else {
																		return null;
																	}
																}
															)}
														</div>
													</section>
												)
											}
										)}
									</>
								}
							</div>
							
						</div>
				
					}
					
					{vars.mobile == false &&
					
						<div className="c-dwork">
							
							<div className="c-dwork__index">
								<div className="c-dwork__index__inner">
									{post.projects &&
										<>
											{post.projects.map((project,i) =>
												{
													return (
														<>
															{project.gallery.map((thumb,j) =>
																{
																	if (j === 0) {
																		return (
																			<div className="c-dwork__index__thumb" key={j}>
																				<Link id={'view-' + project.slug + '-next'} to={{ pathname: project.url }} className="c-dwork__index__thumb__inner">
																					{thumb.type == 'image' &&
																						<Image srcset={thumb.srcset} src={thumb.src} />
																					}
																					{thumb.type == 'cinemagraph' &&
																						<Cinemagraph src={thumb.src} />
																					}
																					<h3 className="c-dwork__index__thumb__heading" dangerouslySetInnerHTML={{__html:project.title}}></h3>
																					<p className="c-dwork__index__thumb__counter" dangerouslySetInnerHTML={{__html:(j + 1) + '/' + project.gallery.length}}></p>
																				</Link>
																			</div>
																		)
																	} else if (j === (project.gallery.length - 1)) {
																		return (
																			<div className="c-dwork__index__thumb" key={j}>
																				<Link id={'view-' + project.slug + '-prev'} to={{ pathname: project.url + '?image=' + project.gallery.length }} className="c-dwork__index__thumb__inner">
																					{thumb.type == 'image' &&
																						<Image srcset={thumb.srcset} src={thumb.src} />
																					}
																					{thumb.type == 'cinemagraph' &&
																						<Cinemagraph src={thumb.src} />
																					}
																					<h3 className="c-dwork__index__thumb__heading" dangerouslySetInnerHTML={{__html:project.title}}></h3>
																					<p className="c-dwork__index__thumb__counter" dangerouslySetInnerHTML={{__html:(j + 1) + '/' + project.gallery.length}}></p>
																				</Link>
																			</div>
																		)
																	} else {
																		return (
																			<div className="c-dwork__index__thumb" key={j}>
																				<Link to={{ pathname: project.url + '?image=' + (j+1)}} className="c-dwork__index__thumb__inner">
																					{thumb.type == 'image' &&
																						<Image srcset={thumb.srcset} src={thumb.src} />
																					}
																					{thumb.type == 'cinemagraph' &&
																						<Cinemagraph src={thumb.src} />
																					}
																					<h3 className="c-dwork__index__thumb__heading" dangerouslySetInnerHTML={{__html:project.title}}></h3>
																					<p className="c-dwork__index__thumb__counter" dangerouslySetInnerHTML={{__html:(j + 1) + '/' + project.gallery.length}}></p>
																				</Link>
																			</div>
																		)
																	}
																}
															)}
														</>
													)
												}
											)}
										</>
									}
								</div>
							</div>
							<div className="c-dwork__slider">
								<Slider ref={sliderRef} {...slickSettings}>
									{slides}
								</Slider>
							</div>
						</div>
							
					}
					
					{post.projects &&
						<>
							{post.projects.map((project,i) =>
								{
									let textHTML = '<h3>' + project.title + '</h3>';
									if (project.information) {
										textHTML = textHTML + project.information;
									}
									if (project.credits) {
										textHTML = textHTML + '<div class="credits">' + project.credits + '</div>';
									}
									let modalClass = 'c-info-modal';
									if (modalIndex === i) {
										modalClass = modalClass + ' state-active';
									}
									return (
										<div className={modalClass}>
											<div className="c-info-modal__inner">
												<div className="scope-information">
													<div dangerouslySetInnerHTML={{__html:textHTML}}></div>
													<p className="close"><Link to={{ pathname: post.projects[i].url}} className="c-dwork__slider__slide__footer__info" dangerouslySetInnerHTML={{__html:'Close'}}></Link></p>
												</div>
											</div>
										</div>
									)
								}
							)}
						</>
					}
					
					<Footer post={post}></Footer>
					
				</div>	
										
			)
			
		} else {
		
			return null;
		
		}
		
	} else {
		
		return null;
		
	}

};
export default WithConsumer(Work);